import * as FIELD_LABEL from 'constant/form-labels'
import * as FIELD_NAME from 'constant/form-item-names'
import { SITE_COLORS } from 'common/constant/site-colors'
import { Form, Select, Badge } from 'antd'
import React from 'react'
import _ from 'lodash'

const { Option } = Select

const ColorInput = () => {
  return (
    <>
      <span>{FIELD_LABEL.PRIMARY_COLOR}</span>
      <Form.Item name={FIELD_NAME.SITE_COLOR}>
        <Select
          bordered={false}
          placeholder={'Color'}
          showSearch={false}
          size='large'
          style={{ background: '#fff' }}
        >
          {SITE_COLORS.map((colorObject) => (
            <Option
              key={colorObject.color}
              value={colorObject.color}
            >
              <Badge color={colorObject.color} />
              {_.startCase(colorObject.name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  )
}

export default ColorInput
